 document.addEventListener('DOMContentLoaded', function () {
    const discountCodeForm = document.querySelector('#cart-discount-form');
    const discountCodeInput = document.querySelector('#discount-code-input');
    const discountCodeSuccess = document.querySelector('#discount-code-success');
    const discountCodeError = document.querySelector('#discount-code-error');
    const fakeCouponContainer = document.querySelector(".fake-coupon__container");
    const fakeCouponBox = document.querySelector(".fake-coupon__box");
    const fakeCouponInput = document.querySelector("#fake-coupon-input");
    const fakeCouponCta = document.querySelector(".fake-coupon--cta");
    const removeDiscountBtn = document.querySelectorAll('.remove-discount-btn');
    const fakeCouponErrMsg = document.querySelector(".fake-coupon__error");
    // const fakeCouponTitle = document.querySelector('.fake-coupon__title');
    // const fakeCouponAcc = document.querySelector('.fake-coupon__acc');
    const discountMsg = document.querySelector('.discount-message');
    const couponList = document
        .querySelector(".coupon-list")
        ?.textContent
        ?.split("/")
        .map(c => c.trim().toUpperCase())
        .filter(Boolean) || [];
    const hideMessages = () => {
      discountCodeSuccess.style.display = "none";
      discountCodeError.style.display = "none";
    };

    const addLoadingUX = () => {
      fakeCouponBox.classList.add("clicked");
    }

    const removeLoadingUX = () => {
      fakeCouponBox.classList.remove("clicked");
    }
  
    const showError = (msg, cart) => {
      discountCodeError.textContent = msg;
      discountCodeError.style.removeProperty('display');

      fakeCouponErrMsg.textContent = msg;
      fakeCouponErrMsg.classList.add('active');
      fakeCouponInput.classList.add("error");
      console.log("💕 fakeCouponInput.value",fakeCouponInput.value, cart)

      const inputCode = fakeCouponInput.value.trim().toUpperCase();

      const POINT_COUPON_PREFIXES = [
        "ANJPMEM",
        "PLATINUM-",
        "GOLD-",
        "SILVER-",
        "DIAMOND-"
      ];

      const isPointCoupon = (code) => {
        const upperCode = code.toUpperCase();
        return POINT_COUPON_PREFIXES.some(prefix =>
          upperCode.startsWith(prefix)
        );
      };

      // 이미 포인트 쿠폰 적용된 상황에서 포인트 쿠폰 또 적용 시
      const hasPointCoupon = cart?.cart_level_discount_applications?.some((discount) =>
        isPointCoupon(discount.title)
      ) || cart?.items?.some((item) =>
        item.discounts?.some((discount) => isPointCoupon(discount.title))
      );

      if (isPointCoupon(inputCode) && hasPointCoupon) {
        fakeCouponErrMsg.textContent = "ポイントクーポンは2枚同時にご使用いただけません。";
      }

      // 자동할인 등 적용된 상황에서 할인율이 더 낮은 포인트 쿠폰 적용 시
      else if (isPointCoupon(inputCode)) {
        fakeCouponErrMsg.textContent = "より割引率の高いクーポンが適用されています。";
      }

      // 중복 적용이 불가능한 쿠폰 적용 시
      else if (couponList.includes(inputCode) || 
          inputCode === "THANK500" ||
          inputCode === "LINE300" ||
          inputCode === "AFFILIATECODE") {
        fakeCouponErrMsg.textContent = "現在適用中のクーポンとは併用できません。";
      }
    };

    fakeCouponInput.addEventListener('click', () => {
      if(fakeCouponErrMsg.classList.contains('active') && fakeCouponInput.classList.contains("error")) {
        fakeCouponInput.value = '';
        discountCodeInput.value = ''; 
        fakeCouponErrMsg.classList.remove('active');
        fakeCouponInput.classList.remove("error");
      }
    });
  
    const showSuccess = (msg) => {
      discountCodeSuccess.textContent = msg;
      discountCodeSuccess.style.removeProperty('display');
    };
  
    const fetchOrShowError = async (label, url) => {
      const localeAwareUrl = window.Shopify.routes.root + url;
      const response = await fetch(localeAwareUrl);
      if (!response.ok) {
        throw new Error(`${label} failed: ${response.status} ${response.statusText}`);
      }
      return response;
    };
  
    const checkForDiscount = (cart, code) => {
        const upperCode = code.toUpperCase(); 

        if (cart.cart_level_discount_applications
            && cart.cart_level_discount_applications.some((app) => app.title.toUpperCase() === upperCode)) {
            return true;
        }

        if (cart.items.some((item) => item.discounts?.some((discount) => discount.title.toUpperCase() === upperCode))) {
            return true;
        }

        return false;
    };

    const fakeCouponHandler = () => {
      fakeCouponInput.addEventListener('input', (e) => {
        discountCodeInput.value = e.target.value.toUpperCase();
      });

      fakeCouponInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          discountCodeInput.value = e.target.value.toUpperCase();
        }
      });

      fakeCouponInput.addEventListener('change', (e) => {
        discountCodeInput.value = e.target.value.toUpperCase();
      });

      fakeCouponCta.addEventListener("click", () => {
        // ✅ submit 전에 직접 값 동기화 + 빈 값 체크
        const code = fakeCouponInput.value.trim();
        discountCodeInput.value = code.toUpperCase();

        if (!code) {
          showError('クーポンコードを入力してください');
          return; // requestSubmit() 자체를 호출 안 함
        }
        // const POINT_COUPON_PREFIXES = [
        //   "ANJPMEM",
        //   "PLATINUM-",
        //   "GOLD-",
        //   "SILVER-",
        //   "DIAMOND-"
        // ];

        // const isLoginRequiredCoupon =
        //   couponList.includes(code) ||
        //   POINT_COUPON_PREFIXES.some(prefix => code.startsWith(prefix)) ||
        //   code === "THANK500" ||
        //   code === "LINE300" ||
        //   code === "AFFILIATECODE";

        // const isLoggedIn = window.isCustomerLoggedIn === true;
        
        // if (!isLoggedIn && isLoginRequiredCoupon) {
        //   fakeCouponErrMsg.textContent = "クーポンコードはログイン後、ご利用できます。";
        //   fakeCouponErrMsg.classList.add('active');
        //   fakeCouponInput.classList.add("error");
        //   discountCodeError.textContent = "クーポンコードはログイン後、ご利用できます。";
        //   discountCodeError.style.removeProperty('display');
        //   removeLoadingUX();
        //   return;
        // }

        if (discountCodeForm) discountCodeForm.requestSubmit();
      });
    }
    
    const getAppliedDiscountTitles = (cart) => {
      const titles = [];

      cart.cart_level_discount_applications?.forEach((app) => {
        if (app.title) titles.push(app.title);
      });

      cart.items?.forEach((item) => {
        console.log("item.product_title",item.product_title);
        console.log("logggg",
          item.discounts?.map(d => ({
            title: d.title,
            amount: d.amount
          }))
        );
        item.discounts?.forEach((discount) => {
          if (discount.title) titles.push(discount.title);
        });
      });

      return [...new Set(titles)];
    };

    discountCodeForm.onsubmit = async (e) => {
      e.preventDefault();
      hideMessages();
      addLoadingUX();

      const code = discountCodeInput.value.trim().toUpperCase();

      try {
        // 적용 전 cart
        const beforeCartResponse = await fetchOrShowError('Before cart fetch', 'cart.js');
        const beforeCart = await beforeCartResponse.json();
        const beforeDiscounts = getAppliedDiscountTitles(beforeCart);

        // 쿠폰 적용
        await fetchOrShowError('Discount application', `discount/${code}`);

        // 적용 후 cart
        const cartResponse = await fetchOrShowError('Cart fetch', 'cart.js');
        const cart = await cartResponse.json();
        const afterDiscounts = getAppliedDiscountTitles(cart);

        console.log("beforeDiscounts", beforeDiscounts);
        console.log("afterDiscounts", afterDiscounts);

        const isApplied = checkForDiscount(cart, code);

        if (isApplied) {
          const removedDiscounts = beforeDiscounts.filter((title) => {
            return title.toUpperCase() !== code && !afterDiscounts.includes(title);
          });

          const isReplaced = removedDiscounts.length > 0;

          if (isReplaced) {
            alert("より割引率の高いクーポンが適用されました。");
          }

          showSuccess('Discount applied! Reloading the page...');
          location.reload();
        } else {
          showError('有効な割引コードを入力してください', cart);      
        }

        removeLoadingUX();
      } catch(e) {
        console.log("👻", e);
        showError('有効な割引コードを入力してください');
        removeLoadingUX();
      }

      
    };
   
    async function removeSingleDiscount(codeToRemove) {
      addLoadingUX()
      const cart = await fetch('/cart.js').then(r => r.json());
      const allCodes = [];
      cart.cart_level_discount_applications?.forEach(app => allCodes.push(app.title));
      cart.items.forEach(item => item.discounts?.forEach(d => allCodes.push(d.title)));
    
      const filtered = [...new Set(allCodes)].filter(c => c !== codeToRemove);
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: filtered.join(',') })
      });
      location.reload();
    }
    
    removeDiscountBtn.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const code = e.currentTarget.dataset.code;
        if (!code) return;
        removeSingleDiscount(code);
      });
    });

    fakeCouponHandler();
    
  });